var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:{ 'header--has-email': !!_vm.email }},[_c('UserProfile',{attrs:{"name":_vm.name,"email":_vm.email,"handle-sign-out":_vm.handleSignOut}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }